import config from "./config"

const ContactServices = {
    // Método original para contacto normal - SE MANTIENE SIN CAMBIOS
    sendContactEmail: (bodyData) => {
        console.log("=== CONTACT SERVICES ===");
        console.log("Datos enviados al servicio:", bodyData);
        console.log("Tipo de datos:", typeof bodyData);
        
        return new Promise((resolve, reject) => {
            // Asegurar que se envía como objeto (axios lo convertirá a JSON automáticamente)
            const dataToSend = typeof bodyData === 'string' ? JSON.parse(bodyData) : bodyData;
            
            console.log("Datos finales a enviar:", dataToSend);
            console.log("JSON de datos:", JSON.stringify(dataToSend));
            console.log("URL completa:", config.defaults.baseURL + "/website/contacto/formulario");
            
            // Hacer la solicitud con headers explícitos
            config.post("/website/contacto/formulario", dataToSend, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(data => {
                    console.log("Respuesta del servicio:", data);
                    resolve(data);
                })
                .catch(err => {
                    console.log("Error del servicio:", err);
                    reject(err);
                });
        });
    },

    // Nuevo método específico para oportunidades laborales
    sendOpportunityEmail: (bodyData) => {
        console.log("=== OPPORTUNITY SERVICES ===");
        console.log("Datos enviados al servicio:", bodyData);
        console.log("Tipo de datos:", typeof bodyData);
        
        return new Promise((resolve, reject) => {
            // Asegurar que se envía como objeto (axios lo convertirá a JSON automáticamente)
            const dataToSend = typeof bodyData === 'string' ? JSON.parse(bodyData) : bodyData;
            
            console.log("Datos finales a enviar:", dataToSend);
            console.log("JSON de datos:", JSON.stringify(dataToSend));
            console.log("URL completa:", config.defaults.baseURL + "/website/contacto/oportunidades");
            
            // Hacer la solicitud con headers explícitos
            config.post("/website/contacto/oportunidades", dataToSend, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(data => {
                    console.log("Respuesta del servicio:", data);
                    resolve(data);
                })
                .catch(err => {
                    console.log("Error del servicio:", err);
                    reject(err);
                });
        });
    }
}

export default ContactServices